var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" İşlem yapmak için partner.trendyol.com'u kullanınız. - İşleminiz için daha önce aksiyon almıştınız. 2 dakika süren kontrollerden sonra ürününüzün kilidi kalkacaktır. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }